<main class="info-container" role="main" aria-labelledby="page-title">
    <div class="info-area" role="region" aria-label="Error: Page Not Found">
        <img
            src="/assets/images/not-found-img.svg"
            width="394px"
            height="275px"
            class="placeholder-image"
            alt=""
            role="presentation"
        />
        <h1 class="title" id="page-title">Oops, we can’t find that page!</h1>
        <h2 *ngIf="locationPhone">
            Please <a [href]="'tel:' + locationPhone">call our office</a> to complete your quote.
        </h2>
    </div>
    <a *ngIf="initialPageUrl" [href]="initialPageUrl" class="link-back">Back to Your Clean page</a>
</main>
